import {match, Pattern} from 'ts-pattern';

import {isNil} from 'ramda';

import {DashboardTileId} from '../types/DashboardTileId';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {allocateDashboardGrid, compareDashboardGridPositions} from './allocateDashboardGrid';
import {applyDashboardGridLayout} from './applyDashboardGridLayout';
import {reconcileDashboardGrid} from './reconcileDashboardGrid';

export function hideDashboardTile(
  placements: DashboardTilePlacement[],
  id: DashboardTileId,
  visibleIds: DashboardTileId[]
): DashboardTilePlacement[] {
  return match(placements.find((tile) => tile.id === id))
    .with(Pattern.nullish, () => placements)
    .with({isVisible: false}, () => placements)
    .when(
      () => !visibleIds.includes(id),
      () => placements
    )
    .otherwise(() => {
      // Reconcile before removal so legacy placements use the board's displayed order too.
      const survivors = reconcileDashboardGrid(
        placements.filter((tile) => visibleIds.includes(tile.id))
      )
        .filter((tile) => tile.id !== id)
        .sort(compareDashboardGridPositions)
        .map(({id: tileId, size}) => ({id: tileId, size}));
      const positioned = allocateDashboardGrid(survivors);

      return isNil(positioned)
        ? placements
        : applyDashboardGridLayout(placements, positioned).map((tile) =>
            tile.id === id ? {...tile, isVisible: false} : tile
          );
    });
}
